const FormFieldTypes = {
    STRING: 'string',
    HIDDEN: 'hidden',
    CHECKBOX: 'checkbox',
    SWITCH: 'switch',
    RADIO: 'radio',
    SELECT: 'select',
    SELECT_MUI3: 'select_mui3',
    SELECT_MUI4: 'select_mui4',
    DATE_TIME: 'date_time',
    DATE: 'date',
    RELATIONSHIP: 'relationship',
    CHIP_SELECT: 'chip_select',
    COMPETENCY_SELECT: 'competency_select',
    AUTO_COMPLETE_SELECT: 'auto_complete_select',
    TEXT_SEARCH: 'text_search',
    FILE: 'file',
    FILE_MUI: 'file_mui',
    TEXT_AREA: 'text_area'
};

export default FormFieldTypes;
